// RadioQuestion.js
import React from "react";
import { RadioOptions } from "./Scl90RadioOptions";

export const RadioQuestion = React.memo(
  ({ id, label, name, value, onChange }) => {
    return (
      <div className="field">
        <div className="control grid--2col">
          <label htmlFor={id}>{label}</label>
          <div className="radio--5-col">
            {RadioOptions.map((option) => (
              <label
                className="radio"
                htmlFor={`${id}-${option.value}`}
                key={option.value}
              >
                <input
                  id={`${id}-${option.value}`}
                  name={name}
                  type="radio"
                  value={option.value}
                  checked={value === option.value}
                  onChange={onChange}
                />
                {option.value}
              </label>
            ))}
          </div>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.value === nextProps.value && prevProps.onChange === nextProps.onChange
);
